import axiosInstance from 'utils/axiosInstance';
import { get } from 'lodash/fp';

const getCountries = () => axiosInstance.get('/ReferenceData/GetCountries').then(get('data'));
const getStates = () => axiosInstance.get('/ReferenceData/GetStates').then(get('data'));
export { getCountries, getStates };
